import * as React           from "react";
import { connect }          from "react-redux";
import { Dispatch }         from "redux";
import AutoLoginResKa       from "../../application/usecase/authentication/AutoLoginResKa";
import GetAuthentication    from "../../application/usecase/authentication/GetAuthentication";
import IdentifyLogRocket    from "../../application/usecase/authentication/IdentifyLogRocket";
import LoginResKa           from "../../application/usecase/authentication/LoginResKa";
import SaveAuthentication   from "../../application/usecase/authentication/SaveAuthentication";
import Account              from "../../domain/account/Account";
import AccountOptionTypes   from "../../domain/account/AccountOptionTypes";
import AccountPlanType      from "../../domain/account/AccountPlanType";
import AccountPlanTypeClass from "../../domain/account/AccountPlanTypeClass";
import AccountRepository    from "../../domain/account/AccountRepository";
import AccountRoleType      from "../../domain/account/AccountRoleType";
import AccountRoleTypeClass from "../../domain/account/AccountRoleTypeClass";
import Authentication       from "../../domain/authentication/Authentication";
import AutoLogin            from "../../domain/authentication/AutoLogin";
import LoginId              from "../../domain/authentication/LoginId";
import LoginPassword        from "../../domain/authentication/LoginPassword";
import Message              from "../../domain/fundamentals/message/Message";
import AccountDataSource    from "../../infrastructure/datasource/account/AccountDataSource";
import RouterDispatcher     from "../../infrastructure/redux/router/RouterDispatcher";
import Footer               from "../components/footer/Footer";
import LoginForm            from "../components/login/LoginForm";

interface Props {
  accountRepository: AccountRepository;
  routerDispatcher: RouterDispatcher;
  autoLoginResKa: AutoLoginResKa;
}

interface State {
  authentication: Authentication;
  message: Message;
  isLoading: boolean;
}

class LoginContainer extends React.Component<Props, State> {
  private readonly getAuthentication: GetAuthentication = new GetAuthentication();
  private readonly saveAuthentication: SaveAuthentication = new SaveAuthentication();
  private readonly loginResKa: LoginResKa = new LoginResKa();
  private readonly identifyLogRocket: IdentifyLogRocket = new IdentifyLogRocket();

  constructor(props: Props) {
    super(props);
    this.state = {
      authentication: Authentication.empty(),
      message: Message.empty(),
      isLoading: false,
    }
  }

  public componentDidMount(): void {
    this.setState({authentication: this.getAuthentication.execute()});
    this.props.autoLoginResKa.execute(value => this.setState({isLoading: value}));
  }

  public render(): React.ReactNode {
    const {authentication, message, isLoading} = this.state;
    return (
      <>
        <LoginForm
          authentication={ authentication }
          message={ message }
          inputLoginId={ (loginId: LoginId) => this.setState({authentication: Authentication.of(loginId, authentication.loginPassword, authentication.autoLogin)}) }
          inputLoginPassword={ (loginPassword: LoginPassword) => this.setState({authentication: Authentication.of(authentication.loginId, loginPassword, authentication.autoLogin)}) }
          checkAutoLogin={ (autoLogin: AutoLogin) => this.setState({authentication: Authentication.of(authentication.loginId, authentication.loginPassword, autoLogin)}) }
          submit={ this.login }
          isLoading={ isLoading }
        />
        <Footer/>
      </>
    );
  }

  private login = async () => {
    const {authentication} = this.state;
    this.setState({isLoading: true});

    try {
      const response = await this.loginResKa.execute(authentication);
      if (authentication.autoLogin.value) {
        this.saveAuthentication.execute(authentication);
      }

      this.identifyLogRocket.execute(response.data ? response.data.name : "法人名がありません");
      const account: Account = new Account(
        new AccountRoleTypeClass(response.data ? response.data.role : AccountRoleType.NONE),
        new AccountPlanTypeClass(response.data ? response.data.plan : AccountPlanType.PLAN_NONE),
        new AccountOptionTypes(response.data ? response.data.options : [])
      );
      this.props.accountRepository.store(account);
      this.props.routerDispatcher.notice();
    } catch (e) {
      this.setState({message: Message.of(e.response ? e.response.data.message : "ログインIDまたはパスワードが間違っています。")});
    } finally {
      this.setState({isLoading: false})
    }

  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  accountRepository: new AccountDataSource(dispatch),
  routerDispatcher: new RouterDispatcher(dispatch),
  autoLoginResKa: new AutoLoginResKa(dispatch),
});

export default connect(null, mapDispatchToProps)(LoginContainer);
